export default "__VITE_ASSET__TLj0ER32__"